<template>
  <div>
    <p>
      Aquest model serveix per a generar<strong>foto de perfil de xarxes socials</strong> per a col·lectius locals o comarcals.
    </p>
    <p>
      Recomanem usar una <strong>foto representativa del poble o comarca</strong>, que puga ser reconeguda amb facilitat al costat de logo, per exemple un edifici
      representatiu o un paisatge fàcil de reconéixer.
    </p>
    <p>
      Els dies importants (Orgull, 8 de Març, 9 d'octubre), podeu utilitzar aquesta ferramenta per a modificar la foto de perfil.
    </p>

    <div class="help-examples">
      <img style="border-radius: 100%" src="./examples/JovesPValc.jpg" alt="Exemple 1:1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'generic-help'
}
</script>
